export enum MenuItemClassEnum {
  noDesplegable = '',
  itemDesplegable = 'menu-toggle',
  subItemDesplegable = 'ml-sub-menu',
}
